import { render, staticRenderFns } from "./RateDossieSelectedGroup.vue?vue&type=template&id=58ec4526&"
import script from "./RateDossieSelectedGroup.vue?vue&type=script&lang=js&"
export * from "./RateDossieSelectedGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports